import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import { components as Core } from '../../core';
import { ParticipantPublisherError } from '../components';
export default angular
    .module('doxy.call.provider-participant-publisher-error', [])
    .component('callParticipantPublisherError', {
    template: '<div></div>',
    bindings: {
        stream: '<',
        variant: '<',
    },
    controller: function ($element) {
        const render = () => {
            ReactDOM.render(React.createElement(Core.withProviders(ParticipantPublisherError), {
                stream: this.stream,
                variant: this.variant,
            }), $element[0]);
        };
        this.$onInit = render;
        this.$onChanges = (changes) => {
            if (changes.variant) {
                render();
            }
        };
    },
}).name;
